import React from 'react';

function FachberaterTerminCalendar({ termine, currentDate, onTerminClick, onMonthChange }) {
  
  const monthNames = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ];

  const weekDays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

  const getWeekDays = (date) => {
    const week = [];
    const startOfWeek = new Date(date);
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1); // Montag als erster Tag
    startOfWeek.setDate(diff);

    for (let i = 0; i < 7; i++) {
      const currentDay = new Date(startOfWeek);
      currentDay.setDate(startOfWeek.getDate() + i);
      week.push(currentDay);
    }
    return week;
  };

  const getTermineForDate = (date) => {
    if (!date) return [];
    
    const dateString = date.toISOString().split('T')[0];
    return termine.filter(termin => {
      const terminDate = new Date(termin.datum).toISOString().split('T')[0];
      return terminDate === dateString;
    }).sort((a, b) => a.uhrzeit.localeCompare(b.uhrzeit));
  };

  const getTerminColor = (index) => {
    const colors = ['#ec4899', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6'];
    return colors[index % colors.length];
  };

  const previousWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() - 7);
    onMonthChange(newDate);
  };

  const nextWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + 7);
    onMonthChange(newDate);
  };

  const weekDates = getWeekDays(currentDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Berechne Wochenbereich für Anzeige
  const startDate = weekDates[0];
  const endDate = weekDates[6];
  const formatDateRange = () => {
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const startMonth = monthNames[startDate.getMonth()];
    const endMonth = monthNames[endDate.getMonth()];
    
    if (startDate.getMonth() === endDate.getMonth()) {
      return `${startDay} - ${endDay} ${startMonth}`;
    } else {
      return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
    }
  };

  return (
    <div className="fachberater-termin-calendar">
      <div className="calendar-header">
        <button onClick={previousWeek} className="month-nav-button">
          ←
        </button>
        <h3>
          {formatDateRange()}
        </h3>
        <button onClick={nextWeek} className="month-nav-button">
          →
        </button>
      </div>

      {/* Wochentage */}
      <div className="weekdays-grid">
        {weekDates.map((date, index) => {
          const isToday = date.getTime() === today.getTime();
          const dayTermine = getTermineForDate(date);
          
          return (
            <div key={index} className={`day-column ${isToday ? 'today' : ''}`}>
              <div className="day-header">
                <div className="weekday-name">{weekDays[index]}</div>
                <div className="weekday-date">{date.getDate()}</div>
              </div>
              
              <div className="day-termine">
                {dayTermine.length === 0 ? (
                  <div className="no-termine">Keine Termine</div>
                ) : (
                  dayTermine.map((termin, terminIndex) => (
                    <div 
                      key={termin.id} 
                      className="fachberater-termin-item"
                      style={{ 
                        backgroundColor: getTerminColor(terminIndex),
                        borderLeft: `4px solid ${getTerminColor(terminIndex)}`
                      }}
                      onClick={() => onTerminClick(termin.id)}
                      title={`${termin.uhrzeit} - ${termin.kunde_name}`}
                    >
                      <div className="termin-time">
                        {termin.uhrzeit.substring(0, 5)}
                        {termin.dauer && (
                          <span className="termin-duration">
                            ({termin.dauer} min)
                          </span>
                        )}
                      </div>
                      <div className="termin-kunde">
                        {termin.kunde_name}
                      </div>
                      {termin.adresse && (
                        <div className="termin-adresse">
                          📍 {termin.adresse}
                        </div>
                      )}
                      {termin.notizen && (
                        <div className="termin-notizen">
                          💬 {termin.notizen.length > 30 ? 
                            termin.notizen.substring(0, 30) + '...' : 
                            termin.notizen
                          }
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .fachberater-termin-calendar {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          max-height: 80vh;
          display: flex;
          flex-direction: column;
        }

        .calendar-header {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
          gap: 20px;
          flex-shrink: 0;
        }

        .calendar-header h3 {
          margin: 0;
          font-size: 1.5rem;
          color: #2d3748;
          text-align: center;
          min-width: 200px;
        }

        .month-nav-button {
          background: #4a6de5;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 8px 12px;
          cursor: pointer;
          font-size: 1rem;
          transition: background-color 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          max-width: 40px;
        }

        .month-nav-button:hover {
          background: #3c5ce0;
        }

        .weekdays-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 1px;
          background: #e2e8f0;
          flex: 1;
          overflow: hidden;
        }

        .day-column {
          background: white;
          display: flex;
          flex-direction: column;
          min-height: 400px;
        }

        .day-column.today {
          background: #f0f8ff;
        }

        .day-header {
          background: #4a6de5;
          color: white;
          padding: 12px 8px;
          text-align: center;
          font-weight: 600;
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex-shrink: 0;
        }

        .day-column.today .day-header {
          background: #e53e3e;
        }

        .weekday-name {
          font-size: 0.9rem;
        }

        .weekday-date {
          font-size: 1.1rem;
          font-weight: 700;
        }

        .day-termine {
          flex: 1;
          padding: 8px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .no-termine {
          color: #a0aec0;
          font-style: italic;
          text-align: center;
          padding: 20px;
          font-size: 0.9rem;
        }

        .fachberater-termin-item {
          background: white;
          border-radius: 6px;
          padding: 12px;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          font-size: 0.85rem;
          line-height: 1.4;
          border: 1px solid #e2e8f0;
        }

        .fachberater-termin-item:hover {
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
        }

        .termin-time {
          font-weight: 700;
          color:rgb(255, 255, 255);
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 0.9rem;
        }

        .termin-duration {
          font-size: 0.75rem;
          color:rgb(255, 255, 255);
          font-weight: 500;
        }

        .termin-kunde {
          font-weight: 600;
          color:rgb(255, 255, 255);
          margin-bottom: 4px;
          font-size: 0.9rem;
        }

        .termin-adresse {
          font-size: 0.8rem;
          color:rgb(255, 255, 255);
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .termin-notizen {
          font-size: 0.8rem;
          color:rgb(255, 255, 255);
          font-style: italic;
          display: flex;
          align-items: flex-start;
          gap: 4px;
        }

        @media (max-width: 768px) {
          .weekdays-grid {
            grid-template-columns: repeat(7, 1fr);
            font-size: 0.8rem;
          }

          .day-column {
            min-height: 300px;
          }

          .day-header {
            padding: 8px 4px;
            font-size: 0.8rem;
          }

          .day-termine {
            padding: 6px;
            gap: 6px;
          }

          .fachberater-termin-item {
            padding: 8px;
            font-size: 0.75rem;
          }

          .calendar-header {
            padding: 15px;
            gap: 15px;
          }

          .calendar-header h3 {
            font-size: 1.2rem;
            min-width: 150px;
          }

          .month-nav-button {
            padding: 6px 10px;
            min-width: 36px;
          }
        }

        @media (max-width: 480px) {
          .weekdays-grid {
            gap: 0;
          }

          .day-column {
            min-height: 250px;
          }

          .day-header {
            padding: 6px 2px;
            font-size: 0.75rem;
          }

          .day-termine {
            padding: 4px;
            gap: 4px;
          }

          .fachberater-termin-item {
            padding: 6px;
            font-size: 0.7rem;
          }

          .termin-adresse,
          .termin-notizen {
            display: none;
          }

          .calendar-header {
            gap: 10px;
          }

          .calendar-header h3 {
            font-size: 1rem;
            min-width: 120px;
          }

          .month-nav-button {
            padding: 4px 8px;
            min-width: 32px;
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
}

export default FachberaterTerminCalendar;